<template>
    <div :class="inSignUp">
        <shows-picker />
    </div>
</template>

<script>
    //import ShowsPicker from "components/ShowsPicker/ShowsPicker";
    import ShowsPicker from 'components/ShowsPicker/ShowsPicker';
    import { mapGetters } from 'vuex';

    const SHOWSPICKER_VARIANT = 'loading_page_and_api';
    const SHOWSPICKER_SIGNUP = 'show_picker_in_sign_up';

    export default {
        name: 'ShowsPickerWrapper',
        components: { ShowsPicker },

        beforeCreate() {
            // Re-route before a component is created to user-profile MFE
            if (
                CBS?.Registry?.Features?.mfe_enabled &&
                CBS.Registry.Features.mfe_userprofiles_enabled
            ) {
                window.location.href = '/user-profile/showpicker';
            }
        },

        beforeDestroy() {
            //add a css class to the main all access container to update styles there
            const mainContainer = document.getElementById('main-container');
            mainContainer.classList.remove('on_show_picker');
            const globalFooter = document.querySelector('footer');
            globalFooter.classList.remove('on_show_picker');
        },

        mounted() {
            if (this['showspicker/inSignupProcess'] === true) {
                this.$nextTick(function () {
                    document.body.classList.add('on_show_picker');
                });
            }
        },

        computed: {
            ...mapGetters(['showspicker/showsPickerVariant', 'showspicker/inSignupProcess']),

            inSignUp() {
                return this['showspicker/inSignupProcess'] ? SHOWSPICKER_SIGNUP : '';
            },

            loadVariant() {
                return this['showspicker/showsPickerVariant'] === SHOWSPICKER_VARIANT;
            },
        },
    };
</script>
